import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';

@Component({
  selector: 'app-form-template-detail',
  templateUrl: './form-template-detail.component.html',
  styleUrls: ['./form-template-detail.component.scss']
})
export class FormTemplateDetailComponent implements OnInit {
  formTemplateData: any = {};
  openSnackbar: any;
  errorStatus: any;
  isProcessing = false;
  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  templateUsersList: any = [];
  isAdenabled: boolean = false;
  constructor(public appService: AppService, public router: Router, private snackBar: MatSnackBar, private authService: MsalService,
    public paginationService: PaginationService, public message: messageService, public dialog: MatDialog,) {
    const data: any = router.getCurrentNavigation()?.extras.state;
    this.formTemplateData = data['formTemplateData'];
    if (this.formTemplateData.createdOn != null) {
      this.formTemplateData.createdOn = new Date(this.formTemplateData.createdOn);
    }
    if (this.formTemplateData.approvalRequestedOn != null) {
      this.formTemplateData.approvalRequestedOn = new Date(this.formTemplateData.approvalRequestedOn);
    }
    if (this.formTemplateData.approvedOn != null) {
      this.formTemplateData.approvedOn = new Date(this.formTemplateData.approvedOn);
    }
    this.formTemplateData.module = "FORMTEMPLATE";
    this.formTemplateData.allowToAddNewForm1 = this.formTemplateData.allowToAddNewForm == "Y";
  }

  visibleInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;

  infoPopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  stagesList: any = [];
  dropDownDataForRepeatIntervalUnit: any = [];
  instructions: any = "";
  buttonLabels: any = [];
  approverDropdown: any = [];
  selectedApprover: any = null;
  oddApprover: any = null
  displayUserName: any;
  ngOnInit() {
    this.formTemplateData.updateReason = '';
    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    this.displayUserName = userData.userNameAtApplication;
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y' ? true : false;
    this.appService.getOneQmsNonorgModuleStagesDetails("FORMS").subscribe((data: any) => {
      this.stagesList = data;
      this.selectBoxForStages();
    })
    this.isProcessing = true;
    this.appService.getFormTemplateApprovers().subscribe((data: any) => {
      this.isProcessing = false;
      for (let i = 0; i < data.length; i++) {
        this.approverDropdown = this.approverDropdown.concat({
          valueExp: data[i].userId,
          displayExp: data[i].userFullname
        });
      }


      if (this.formTemplateData.approvedBy) {
        const matchingApprover = data?.find((item: any) => item.userId == this.formTemplateData.approvedBy);
        if (!matchingApprover) {
          this.oddApprover = this.formTemplateData.approvedBy;
          this.approverDropdown.push({
            valueExp: this.formTemplateData.approvedBy,
            displayExp: this.formTemplateData.approvedUserByUser
          })
        }
        this.selectedApprover = this.formTemplateData.approvedBy
      }
    })
    if (!this.formTemplateData.isAddForm) {

      this.buttonCall();

    }
    this.labelcall();

  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: "ONEQMS_FORM_TEMPLATES_VW",
      moduleName: null,
      gridName: 'FORM_TEMPLATE',
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe((data: any) => {
      this.label = data;
      this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
        acc[`${user.columnName}`] = user.changedFieldName;
        return acc;
      }, {});
      console.log(this.dynamicLabel);
      this.isProcessing = false;
      //this.label = data;
    }, (error: any) => {
      this.isProcessing = false;
    });
  }


  saveButtonForTemplate = false;
  buttonCall() {
    setTimeout(() => {
      this.appService.getFormTemplateByTemplateId(this.formTemplateData.templateId).subscribe((response: any) => {
        this.formTemplateData.status = response[0].status;



        let data = {

          templateId: this.formTemplateData.templateId,
          status: this.formTemplateData.status
        }
        this.buttonLabels = [];
        this.formTemplateData['saveButtonForTemplate'] = false;
        this.saveButtonForTemplate = false;
        this.appService.getButtonLabelsForFormTemplate(data).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.instructions = data.instructions;
            if (data.buttonLabels != null) {
              this.buttonLabels = data.buttonLabels.split(",");
              for (let i = 0; i < this.buttonLabels.length; i++) {
                if (this.buttonLabels[i] == "Save") {
                  this.saveButtonForTemplate = true;
                  this.formTemplateData['saveButtonForTemplate'] = true;
                  this.buttonLabels = this.buttonLabels.filter((obj: string) => { return obj !== "Save" });
                  i--;
                }
                if (this.buttonLabels[i] == "Cancel") {
                  this.buttonLabels = this.buttonLabels.filter((obj: string) => { return obj !== "Cancel" });
                  i--;
                }
              }

            }
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: data.resultType == 'S' ? 5000 : undefined,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }
        })
        this.labelcall();
      });
    })
  }

  @ViewChild('fieldPopup', { static: true }) fieldPopup: TemplateRef<any>;
  visibleFieldPopup: MatDialogRef<TemplateRef<any>>;
  fieldPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  @ViewChild('performOperation', { static: true }) performOperation: TemplateRef<any>;
  performOperationPopup: MatDialogRef<TemplateRef<any>>;
  performOperationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  backToFormTemplate() {
    this.message.breadcrumbData.thirdLevel = "Forms and Logs";
    history.back();
  }

  templateName: any;
  templateNameRequiredMsg: any;
  stageName: any;
  stageNameRequiredMsg: any;
  updateReq: any;
  updateReqMsg: any;

  fieldValidation() {
    this.templateName = document.getElementById('templateName') as HTMLInputElement;
    this.templateNameRequiredMsg = document.getElementById('templateName-required-msg') as HTMLInputElement;

    this.stageName = document.getElementById('stageName') as HTMLInputElement;
    this.stageNameRequiredMsg = document.getElementById('stageName-required-msg') as HTMLInputElement;

    this.updateReq = document.getElementById('update') as HTMLInputElement;
    this.updateReqMsg = document.getElementById('update-required-msg') as HTMLInputElement;

    if (this.formTemplateData.templateName == "") {
      this.templateName.style.border = '1px solid red';
      this.templateNameRequiredMsg.style.display = 'block';
    } else {
      this.templateName.style.border = 'none';
      this.templateNameRequiredMsg.style.display = 'none';
    }

    if (this.selectedStages.length == 0) {
      this.stageName.style.border = '1px solid red';
      this.stageNameRequiredMsg.style.display = 'block';
    } else {
      this.stageName.style.border = 'none';
      this.stageNameRequiredMsg.style.display = 'none';
    }

    if (this.saveButtonForTemplate) {
      if (!this.formTemplateData.updateReason) {
        this.updateReq.style.border = '1px solid red';
        this.updateReqMsg.style.display = 'block';
      } else {
        this.updateReq.style.border = 'none';
        this.updateReqMsg.style.display = 'none';
      }
    }
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  updateFormTemplate(trainingGroupFieldData: any) {
    if (this.isSwitchingUser) {
      this.formTemplateData.updateReason = 'user switched';
      this.isSwitchingUser = false;
    }
    this.isProcessing = true;
    if (this.formTemplateData.templateName == "" || this.selectedStages.length == 0 || (this.saveButtonForTemplate && !this.formTemplateData.updateReason)) {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      this.fieldValidation();
      delete this.formTemplateData.updatedOn;
      delete this.formTemplateData.approvalRequestedOn;
      if (this.formTemplateData.createdOn != null) {
        this.formTemplateData.createdOn = new Date(this.formTemplateData.createdOn);
      }
      if (this.formTemplateData.approvedOn != null) {
        this.formTemplateData.approvedOn = new Date(this.formTemplateData.approvedOn);
      }

      this.formTemplateData.allowToAddNewForm = this.formTemplateData.allowToAddNewForm1 ? "Y" : "N";
      this.formTemplateData.approvedBy = this.selectedApprover ?? null;
      this.formTemplateData.listOfStages = "";
      if (this.selectedStages.length > 0) {
        this.formTemplateData.listOfStages = this.selectedStages.join(",");
      }
      this.appService.updateFormTemplate(this.formTemplateData).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == 'S') {
          if (Response.resultType == 'S') {
            this.formTemplateData.updateReason = '';
          }
        } else {
          if (Response.result.includes("The current user cannot be approver")) {
            this.selectedApprover = this.previousSelectedApprover;
            this.buttonCall();
          }
        }
        this.showSnackBar(Response.result, Response.resultType);
        this.isSwitchingUser && (this.isSwitchingUser = false);
      }, (error) => {
        this.isProcessing = false;
        throw error;
      });
    }
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: !this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.secondLevel
          : this.message.breadcrumbData.thirdLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  selectedStages: any = [];
  stagesDropdown: any = [];
  selectBoxForStages() {
    for (let i = 0; i < this.stagesList.length; i++) {
      this.stagesDropdown = this.stagesDropdown.concat({
        valueExp: this.stagesList[i].oneQmsNonorgModuleStagesPk.stageName,
        displayExp: this.stagesList[i].oneQmsNonorgModuleStagesPk.stageName
      });
    }
    /*     if (this.formTemplateData.listOfStages != null) {
          let filteredStages = this.formTemplateData.listOfStages.split(",");
          this.selectedStages = [];
          for (let k = 0; k < filteredStages.length; k++) {
            this.selectedStages.push({
              valueExp: filteredStages[k],
              displayExp: filteredStages[k]
            })
          }
        } */
    if (this.formTemplateData.listOfStages) {
      this.selectedStages = this.formTemplateData.listOfStages.split(',');
      setTimeout(() => {
        this.isStagesSelected = this.stagesDropdown.length == this.selectedStages.length;
        this.formTemplateData.listOfStages.split(',').length == this.stagesList.length && this.stages.options.forEach((item: MatOption) => item.select());
      })

    }
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  @ViewChild('stages') stages: MatSelect;
  isStagesSelected = false;


  toggleAllSelection(value: any) {
    if (value == 'stages') {
      if (this.isStagesSelected) this.stages.options.forEach((item: MatOption) => item.select());
      else this.stages.options.forEach((item: MatOption) => item.deselect());
    }

  }
  approversearchTxt: any;
  stagesSearchText: any;
  onStageSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.isStagesSelected = this.stagesDropdown.length == this.selectedStages.length; })
    }
  }


  isShowTrainingsGrid = false;
  onTabChanged($event: any) {
    let data = $event.tab.textLabel;
    if (data == "Trainings") {
      this.isShowTrainingsGrid = true;
    }
  }

  openFormTemplateFields() {
    this.formTemplateData['isFrom'] = "Template";
    this.visibleFieldPopup = this.dialog.open(this.fieldPopup, this.fieldPopupConfig);

  }

  cancelFieldPopup() {
    this.visibleFieldPopup.close();
  }

  title: any = "";
  comments: any = "";
  userName: any = "";
  password: any = "";
  warningMsg: any = "";
  dynamicButtonClick(value: any) {

    this.title = value;
    this.userName = localStorage.getItem("loggedUserName");
    this.password = "";
    this.comments = "";
    if (value == "Send for Approval") {
      this.isProcessing = true;
      this.appService.getAddedFormUsers(this.formTemplateData.templateId, 0)
        .subscribe((data: any) => {
          this.templateUsersList = data;
          this.isProcessing = false;
          if (this.templateUsersList.length == 0) {
            //alert("Please add template users before "+value);
            this.warningMsg = "Please add template users before " + value;
            this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
          } else {
            this.performOperationPopup = this.dialog.open(this.performOperation, this.performOperationPopupConfig);
          }
        })

    } else if (value == "Preview/Launch") {
      this.formTemplateData.formId = this.formTemplateData.templateId;
      this.formTemplateData.isFrom = "TEMPLATE"
      this.router.navigate(['/dashboard/formsAndLogsDetail'], {
        state: {
          formObj: this.formTemplateData
        }
      });
    } else {
      this.performOperationPopup = this.dialog.open(this.performOperation, this.performOperationPopupConfig);
    }


  }

  datePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY HH:mm:ss',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  dateCustomClasses: DatepickerDateCustomClasses[];
  commentFiledValueRequiredMsg: any;
  commentValidation() {
    if (this.title != 'Send for Approval') {
      this.commentFiledValueRequiredMsg = document.getElementById('comments-required-msg') as HTMLInputElement;
      if (this.commentFieldValue.value == '' || this.commentFieldValue.value == undefined || this.commentFieldValue.value == null) {
        this.isProcessing = false;
        this.commentFieldValue.style.border = '1px solid red';
        this.commentFiledValueRequiredMsg.style.display = 'block';
      } else {
        this.commentFieldValue.style.border = 'none';
        this.commentFiledValueRequiredMsg.style.display = 'none';
      }
    }

    if (this.title == "Approve") {
      this.passwordFiledValueRequiredMsg = document.getElementById('password-required-msg') as HTMLInputElement;
      if (this.passwordFieldValue.value == '' || this.passwordFieldValue.value == undefined || this.passwordFieldValue.value == null) {
        this.isProcessing = false;
        this.passwordFieldValue.style.border = '1px solid red';
        this.passwordFiledValueRequiredMsg.style.display = 'block';
      } else {
        this.passwordFieldValue.style.border = 'none';
        this.passwordFiledValueRequiredMsg.style.display = 'none';
      }
    }

    if (this.title == 'Send for Approval') {
      this.approverFieldValueReqdValue = document.getElementById('approver-required-msg') as HTMLInputElement;
      if (!this.selectedApprover) {
        this.isProcessing = false;
        this.approverFieldValue.style.border = '1px solid red';
        this.approverFieldValueReqdValue.style.display = 'block';
      } else {
        this.approverFieldValue.style.border = 'none';
        this.approverFieldValueReqdValue.style.display = 'none';
      }
    }

  }

  passwordFieldValue: any
  passwordFiledValueRequiredMsg: any;
  approverFieldValue: any;
  approverFieldValueReqdValue: any;

  commonButtonOperation() {
    let data = {

      templateId: this.formTemplateData.templateId,
      status: this.formTemplateData.status,
      buttonValue: this.title,
      comments: this.comments
    }
    this.appService.performButtonOperationForFormTemplate(data).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == 'S') {
        if (this.title == "Delete") {
          this.backToFormTemplate();
        } else {
          this.appService.getFormTemplateByTemplateId(this.formTemplateData.templateId).subscribe((response: any) => {
            this.formTemplateData = response[0];
            if (this.formTemplateData.createdOn != null) {
              this.formTemplateData.createdOn = new Date(this.formTemplateData.createdOn);
            }
            if (this.formTemplateData.approvalRequestedOn != null) {
              this.formTemplateData.approvalRequestedOn = new Date(this.formTemplateData.approvalRequestedOn);
            }
            if (this.formTemplateData.approvedOn != null) {
              this.formTemplateData.approvedOn = new Date(this.formTemplateData.approvedOn);
            }
            this.formTemplateData.module = "FORMTEMPLATE";
            this.formTemplateData.allowToAddNewForm1 = this.formTemplateData.allowToAddNewForm == "Y" ? true : false;
            /*             if (this.formTemplateData.listOfStages != null) {
                          let filteredStages = this.formTemplateData.listOfStages.split(",");
                          this.selectedStages = [];
                          for (let k = 0; k < filteredStages.length; k++) {
                            this.selectedStages.push({
                              valueExp: filteredStages[k],
                              displayExp: filteredStages[k]
                            })
                          }
                        } */
            if (this.formTemplateData.listOfStages) {
              this.selectedStages = this.formTemplateData.listOfStages.split(',');
              setTimeout(() => {
                this.isStagesSelected = this.stagesDropdown.length == this.selectedStages.length;
                this.formTemplateData.listOfStages.split(',').length == this.stagesList.length && this.stages.options.forEach((item: MatOption) => item.select());
              })

            }
            this.isProcessing = false;
            this.buttonCall();
          })
        }

        this.performOperationPopup.close();
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });

    }, (error) => {
      this.isProcessing = false;
      throw error;
    });
  }

  authEnable(flag: string) {
    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          console.log(result.account?.username);
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            this.commonButtonOperation();
          } else {
            // console.log("outside");
          }
        },
        error: (error) => {
          this.isProcessing = false;
        }
      });
  }

  commentFieldValue: any;
  perfomrOpernFunc() {
    if (this.title == "Approve") {
      this.isProcessing = true;
      this.passwordFieldValue = document.getElementById('password') as HTMLInputElement;
      this.commentFieldValue = document.getElementById('comments') as HTMLInputElement;

      if ((this.commentFieldValue && (this.commentFieldValue.value == '' || this.commentFieldValue.value == undefined || this.commentFieldValue.value == null)) || ((localStorage.getItem("adEnabled") != 'Y') && (this.passwordFieldValue && (this.passwordFieldValue.value == '' || this.passwordFieldValue.value == undefined || this.passwordFieldValue.value == null)))
      ) {
        this.commentValidation();
        this.isProcessing = false;
      } else if (localStorage.getItem("adEnabled") == 'Y') {
        this.authEnable("Approve");
      } else {
        let data = {
          userName: this.userName,
          password: this.password,
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.commonButtonOperation();
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }
        })
      }
    } else if (this.title == "Send for Approval") {
      this.isProcessing = true;
      this.approverFieldValue = document.getElementById('approver') as HTMLInputElement;
      if (!this.selectedApprover) {
        this.commentValidation();
        this.isProcessing = false;
      } else {
        delete this.formTemplateData.createdOn;
        if (this.formTemplateData.approvalRequestedOn != null) {
          this.formTemplateData.approvalRequestedOn = new Date(this.formTemplateData.approvalRequestedOn);
        }
        if (this.formTemplateData.approvedOn != null) {
          this.formTemplateData.approvedOn = new Date(this.formTemplateData.approvedOn);
        }
        delete this.formTemplateData.updatedOn;
        //delete this.formTemplateData.approvalRequestedOn;

        this.formTemplateData.allowToAddNewForm = this.formTemplateData.allowToAddNewForm1 ? "Y" : "N";
        this.formTemplateData.approvedBy = this.selectedApprover ?? null;
        this.formTemplateData.listOfStages = "";
        if (this.selectedStages.length > 0) {
          /*           for (let k = 0; k < this.selectedStages.length; k++) {
                      this.formTemplateData.listOfStages += this.selectedStages[k].valueExp;
                      this.formTemplateData.listOfStages += k == this.selectedStages.length - 1 ? "" : ",";
                    } */
          this.formTemplateData.listOfStages = this.selectedStages.join(",");
        };
        this.appService.updateFormTemplate(this.formTemplateData).subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == 'S') {
            this.commonButtonOperation();
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel == null ? this.message.breadcrumbData.secondLevel : this.message.breadcrumbData.thirdLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }

        }, (error) => {
          this.isProcessing = false;
          throw error;
        });
      }
    } else {
      this.isProcessing = true;
      this.commentFieldValue = document.getElementById('comments') as HTMLInputElement;
      if (this.commentFieldValue.value == '' || this.commentFieldValue.value == undefined || this.commentFieldValue.value == null) {
        this.commentValidation();
        this.isProcessing = false;
      } else {
        this.commonButtonOperation();
      }
    }
  }

  cancelOperationFunc() {
    this.performOperationPopup.close();
  }

  okInfo() {
    this.visibleInfoPopup.close();
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  @ViewChild(SwitchuserComponent) switchUserComponent!: SwitchuserComponent;

  isSwitchingUser: boolean = false;
  previousSelectedApprover: any;
  openSwitchUser(userBeingSwitched: any) {
    this.isSwitchingUser = true;
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = null;
    this.message.switchuserRole = userBeingSwitched;
    if (userBeingSwitched == "Approver") {
      this.message.switchedUser = this.previousSelectedApprover = this.selectedApprover;
      this.message.switchUserCurrentValue = this.selectedApprover;
      this.message.switchUserdropDownList = this.approverDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    }
    this.switchUserComponent.openswitchuser(userBeingSwitched, "FLS");
  }

  onChildValueEmitted() {
    if (this.message.switchuserRole == "Approver") {
      if (this.message.switchedUser == this.formTemplateData.createdBy) {
        this.showSnackBar("The Approver cannot be the same as the Created By user.", "E");
        return;
      }
      this.selectedApprover = this.message.switchedUser;
    }
    this.updateFormTemplate(this.formTemplateData);
    this.switchUserComponent.visibleswitchUserPopup.close();
    this.switchUserComponent.visibleConfirmationPopup.close();
  }

}
